import { MultiViewBranchInfo } from "../../models/MultiViewBranchInfo";
import { constants } from "../../constants";
import { eBranches } from "sb-resp-lib";
import { BranchInfoLegacy, BranchConfigData } from "../../../../../interfaces";
export class MultiViewBranchInfoParser {

    public static Parse(branchData: BranchInfoLegacy, config?: BranchConfigData): MultiViewBranchInfo {
        let marketNames = config ? this.getBranchMarketNames(config) : {};

        return new MultiViewBranchInfo({
            id: branchData.ID.toString(),
            name: branchData.Name,
            sortId: branchData.SortID * 1,
            code: branchData.Code,
            leagueIds: [],
            marketNames,
            enetPulseID: branchData.EnetPulseID
        });
    }

    private static getBranchMarketNames(branchConfig: BranchConfigData): Object {
        let branchMarketNames = {};
        branchConfig.MarketKeys.forEach((key) => {
            let marketMappedTypeId = constants.typeIDMap[key];
            let marketSelectionNames = constants.supportedMarkets[marketMappedTypeId];
            if (marketSelectionNames && marketMappedTypeId) {
                branchMarketNames[marketMappedTypeId] = new Array().concat(marketSelectionNames);
            }
        });
        // if basketball or tennis and market is FullTime-ML - remove the middle selection name
        let configBranchID = branchConfig.BranchID;

        (configBranchID === eBranches.Basketball || configBranchID === eBranches.Tennis) &&
            branchMarketNames["FT_ML"] && branchMarketNames["FT_ML"].splice(1, 1);

        // if icehockey change the phrase for FT_OU_1 which is point to goals
        MultiViewBranchInfoParser.changeOUForIceHockey(configBranchID, branchMarketNames);

        return branchMarketNames;
    }

    private static changeOUForIceHockey(configBranchID: number, branchMarketNames: {}) {
        if (configBranchID === eBranches.IceHockey &&
            branchMarketNames["FT_OU"] && branchMarketNames["FT_OU"][0]) {
            branchMarketNames["FT_OU"][0] = "FT_OU_1_7";
        }
    }
}